import useGetPressureLookupTemperature from "../hooks/useGetPressureLookupTemperature";
import DataTable from '../../../components/DataTable/DataTable';
import { useState } from "react";
const INIT_PAGE = 1;
const INIT_ORDER = "minPressure";
const INIT_ORDER_DIRECTION = 0

const PressureLookupTemperature = () => {

    const { pressureLookupData, loading } = useGetPressureLookupTemperature();
    const [currentPage, setCurrentPage] = useState(INIT_PAGE);
    const handleCurrentPageChange = (current) => {
        setCurrentPage(current);
    }

    return (
        <div className="probability-score-grid">
            {loading ? (
                <div className="loading">Loading...</div>
            ) : (
                <DataTable
                    count={pressureLookupData?.length}
                    columns={[
                        {
                            header: "Minimum Pressure (barg)",
                            accessorFn: (row) => row?.minPressure,
                            id: "minPressure",
                        },
                        {
                            header: "Maximum Pressure (barg)",
                            accessorFn: (row) => row?.maxPressure,
                            id: "maxPressure",
                        },
                        {
                            header: "Temperature (°C)",
                            accessorFn: (row) => row?.temperature,
                            id: "temperature",
                        }
                    ]}
                    data={pressureLookupData}
                    currentPage={currentPage}
                    handleCurrentPageChange={handleCurrentPageChange}
                    handleOrderChange={() => {}}
                    INIT_ORDER={INIT_ORDER}
                    INIT_ORDER_DIRECTION={INIT_ORDER_DIRECTION}
                    loading={loading}
                    paginationMode="client"
                />
            )}
        </div>
    );
};

export default PressureLookupTemperature;